import { render } from "./FeedBackSamoprocenaCompanyComponent.vue?vue&type=template&id=2c505dc4&scoped=true&lang=html"
import script from "./FeedBackSamoprocenaCompanyComponent.vue?vue&type=script&lang=js"
export * from "./FeedBackSamoprocenaCompanyComponent.vue?vue&type=script&lang=js"

import "./FeedBackSamoprocenaCompanyComponent.vue?vue&type=style&index=0&id=2c505dc4&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-2c505dc4"

export default script